import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { DsSpinner } from "../../../design-system";
import { assetService } from "../../../services/api";

export default function AssetHistoryDrawer({ open, asset, onClose }) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!open || !asset?.id) return;
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await assetService.getAssetHistory(asset.id);
        const list = res?.data?.history || res?.data || res?.history || [];
        if (!cancelled) setItems(Array.isArray(list) ? list : []);
      } catch {
        if (!cancelled) setItems([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [open, asset]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/30">
      <button type="button" className="flex-1 cursor-default" aria-label="Close" onClick={onClose} />
      <aside className="flex h-full w-full max-w-md flex-col border-l border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] shadow-xl">
        <div className="flex items-center justify-between border-b border-[hsl(var(--ds-border))] px-4 py-3">
          <div>
            <h3 className="ds-h4 text-[hsl(var(--ds-fg))]">Asset History</h3>
            <p className="ds-caption text-[hsl(var(--ds-muted-fg))]">
              {asset?.tag || asset?.assetTag || asset?.name}
            </p>
          </div>
          <button type="button" onClick={onClose} className="rounded p-1 text-[hsl(var(--ds-muted-fg))] hover:bg-[hsl(var(--ds-muted))]">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          {loading ? (
            <div className="flex justify-center py-10">
              <DsSpinner />
            </div>
          ) : items.length === 0 ? (
            <p className="ds-caption text-[hsl(var(--ds-muted-fg))]">No movements recorded.</p>
          ) : (
            <ol className="relative space-y-4 border-l border-[hsl(var(--ds-border))] pl-4">
              {items.map((row, idx) => {
                const when = row.createdAt || row.created_at || row.date || "";
                const action = row.action || row.type || row.event || "Movement";
                const note = row.notes || row.note || row.description || "";
                return (
                  <li key={row.id || idx} className="relative">
                    <span className="absolute -left-[1.35rem] top-1 h-2.5 w-2.5 rounded-full bg-[hsl(var(--ds-primary))]" />
                    <p className="ds-body font-medium text-[hsl(var(--ds-fg))]">{action}</p>
                    <p className="ds-caption text-[hsl(var(--ds-muted-fg))]">
                      {when ? new Date(when).toLocaleString() : "—"}
                    </p>
                    {note ? <p className="ds-caption mt-1 text-[hsl(var(--ds-fg))]">{note}</p> : null}
                  </li>
                );
              })}
            </ol>
          )}
        </div>
      </aside>
    </div>
  );
}
